<template>
  <document-registry-page
    :fixed-document-type="documentType"
    :page-title="pageTitle"
    :read-only-registry="readOnlyRegistry"
  />
</template>

<script>
import DocumentRegistryPage from './DocumentRegistryPage.vue'

export default {
  name: 'documents_list',
  components: { DocumentRegistryPage },
  props: {
    documentType: { type: String, default: '' },
    pageTitle: { type: String, default: '' },
    readOnlyRegistry: { type: Boolean, default: false }
  }
}
</script>
